export default __webpack_public_path__ + "static/FReg-4x3-S_Baking-1b977bf40781ed076cbff465d67fb657.jpg";